<template>
  <v-card-text>
    {{ title }}
  </v-card-text>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";

@Component({
  name: "DemoComp1",
  props: {
    value: {
      default: null,
    },
  },
})
export default class DemoComp1 extends Vue {
  title = "Demo Comp-1 default";

  async mounted() {
    this.$root.$on("event.expenses.add", (data) => {
      this.title = data;
    });
  }
}
</script>
